<script setup>
import { FormSection, FormInput, FormListbox, FormTextarea } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { styles } from "@Utils/persona.js";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { useI18n } from "vue-i18n";
import { MagicIcon } from "@Icons/index";
import { ref } from "vue";

const props = defineProps({
    persona: Object,
});

const { t: __ } = useI18n();

const processing = ref(false);
const form = useForm({
    id: props.persona.id,
    first_name: props.persona.user?.user_meta?.first_name?.[0],
    last_name: props.persona.user?.user_meta?.last_name?.[0],
    job: props.persona.job,
    writing_style: props.persona.writing_style,
    age: props.persona.age,
    description: props.persona.user?.user_meta?.description?.[0],
    custom_instructions: props.persona.custom_instructions,
});

const updateProfil = () => {
    if (form.processing) return;

    form.post("personas_update_profil");
};

const generateBiography = async () => {
    if (processing.value.processing) return;
    processing.value = true;

    const response = await useForm({
        language: props.persona.language,
        first_name: props.persona.user?.user_meta?.first_name?.[0],
        last_name: props.persona.user?.user_meta?.last_name?.[0],
        job: props.persona.job,
        writing_style: props.persona.writing_style,
        age: props.persona.age,
    }).post("personas_generate_biography");

    form.description = response.description;

    processing.value = false;
};
</script>

<template>
    <FormSection @submitted="updateProfil">
        <template #title> Profil </template>

        <template #form>
            <div class="sm:col-span-3">
                <FormInput :label="__('Prénom')" v-model="form.first_name" :errors="form.errors.get('first_name')" required />
            </div>

            <div class="sm:col-span-3">
                <FormInput :label="__('Nom')" v-model="form.last_name" :errors="form.errors.get('last_name')" />
            </div>

            <div class="sm:col-span-3">
                <FormInput :label="__('Âge')" v-model="form.age" type="number" min="18" max="99" :errors="form.errors.get('age')" required />
            </div>

            <div class="sm:col-span-3 sm:col-start-1">
                <FormInput :label="__('Profession, passion ou loisir')" v-model="form.job" :errors="form.errors.get('job')" required />
            </div>

            <div class="sm:col-span-3">
                <FormListbox
                    :label="__('Style')"
                    v-model="form.writing_style"
                    :items="styles"
                    item-key="key"
                    item-display="name"
                    required
                    :errors="form.errors.get('writing_style')" />
            </div>

            <div class="sm:col-span-full">
                <FormTextarea
                    v-model="form.description"
                    :rows="10"
                    :label="__('Biographie')"
                    :errors="form.errors.get('description')"
                    :left-actions="[
                        {
                            id: 'generate',
                            icon: MagicIcon,
                            processing: processing,
                            label: __('Générer'),
                            onClick: generateBiography,
                        },
                    ]">
                </FormTextarea>
            </div>

            <div class="sm:col-span-full">
                <FormTextarea
                    v-model="form.custom_instructions"
                    :rows="10"
                    :label="__('Instructions personnalisées')"
                    :errors="form.errors.get('custom_instructions')"
                    :left-actions="[
                        {
                            id: 'magic-prompt',
                        },
                    ]"
                    :right-actions="[
                        {
                            id: 'maximize',
                        },
                    ]">
                </FormTextarea>
            </div>
        </template>

        <template #actions>
            <PrimaryButton :processing="form.processing"> {{ __("Sauvegarder") }} </PrimaryButton>
            <ActionMessage :on="form.recentlySuccessful" class="ml-3"> {{ __("Sauvegardé.") }} </ActionMessage>
        </template>
    </FormSection>
</template>
